import React from "react";

import "./project_details.less";
import JointVentureIcon from "@src/assets/icons/handshake.svg";
import { CardLabel } from "@src/components/card_label";
import { EmployeeName } from "@src/components/employee_name/index";
import { ProjectPhaseChip } from "@src/components/project_phase_chip";
import { Technologies } from "@src/components/technologies";
import { Project } from "@src/types";
import dayjs from "dayjs";

interface ProjectDetailsProps {
  project: Project;
  isLoading?: boolean;
}

const ProjectDetails: React.FC<ProjectDetailsProps> = ({
  project,
  isLoading,
}) => {
  const technologies = project?.technologies.join(", ");

  return (
    <div className="project-details">
      <CardLabel
        label="Phase"
        toolTip={project?.projectPhase}
        isLoading={isLoading}
      >
        <ProjectPhaseChip projectPhase={project?.projectPhase} />
      </CardLabel>
      <CardLabel
        label="Project manager"
        isLoading={isLoading}
        toolTip={project?.projectManager.fullName}
      >
        <EmployeeName name={project?.projectManager.fullName} />
      </CardLabel>
      {project?.jointVenturePartner && (
        <CardLabel
          label="Joint Venture Partner"
          isLoading={isLoading}
          toolTip={project?.jointVenturePartner}
        >
          <JointVentureIcon className="project-details-jv-icon" />
          {project?.jointVenturePartner}
        </CardLabel>
      )}
      <CardLabel label="Technology" showToolTip={false} isLoading={isLoading}>
        <Technologies technologies={technologies} />
      </CardLabel>
      <CardLabel label="Region/Country" isLoading={isLoading}>
        {project?.regionName || "N.A."} / {project?.country}
      </CardLabel>
      <CardLabel label="Project time" isLoading={isLoading}>
        {dayjs(project?.startDate).format("Do MMMM YYYY")} -{" "}
        {dayjs(project?.endDate).format("Do MMMM YYYY")}
      </CardLabel>
      <CardLabel label="Next stage gate" isLoading={isLoading}>
        {dayjs(project?.stageGateDate).format("Do MMMM YYYY")}
      </CardLabel>
      <CardLabel label="Last updated" isLoading={isLoading}>
        {dayjs(project?.lastEdit).format("Do MMMM YYYY")}
      </CardLabel>
    </div>
  );
};

export default ProjectDetails;
